import { render, staticRenderFns } from "./VerticalCarrouselSection.vue?vue&type=template&id=67fb6648&scoped=true&"
import script from "./VerticalCarrouselSection.vue?vue&type=script&lang=js&"
export * from "./VerticalCarrouselSection.vue?vue&type=script&lang=js&"
import style0 from "./VerticalCarrouselSection.vue?vue&type=style&index=0&id=67fb6648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb6648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
